import { defineComponent as _defineComponent } from 'vue';
import InputNumber from 'primevue/inputnumber';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import { reactive, ref, watch, watchEffect } from 'vue';
import OrchardService from '@/Services/OrchardService';
import PlotService from '@/Services/PlotService';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { DateTime } from 'luxon';
import { useSpinner } from '@/Plugins/spinner';
import { useMitt } from '@/Plugins/mitt';
import MultiSelect from 'primevue/multiselect';
import IrrigationService from '@/Services/IrrigationService';
import { trans, transChoice } from 'laravel-vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditCreate',
    props: {
        data: {
            type: Object,
            default: {},
        },
    },
    emits: ['cancel', 'saved'],
    setup(__props, { expose, emit }) {
        expose();
        const props = __props;
        const orchardService = new OrchardService();
        const plotService = new PlotService();
        const spinner = useSpinner();
        const emitter = useMitt();
        const orchards = ref([]);
        const plots = ref([]);
        const irrigationService = new IrrigationService();
        const data = reactive({
            orchard_id: props.data.orchard?.id,
            plot_ids: props.data.plots ? props.data.plots.map((p) => p.id) : [],
            date: (props.data.date ? DateTime.fromISO(props.data.date) : DateTime.utc()).toJSDate(),
            volume: props.data.volume,
        });
        const rules = {
            orchard_id: { required },
            plot_ids: { required },
            date: { required },
            volume: { required },
        };
        const v$ = useVuelidate(rules, data);
        orchardService.getAll().then((options) => orchards.value = options);
        watchEffect(() => {
            if (data.orchard_id !== undefined) {
                plotService.getAllByOrchard(data.orchard_id).then((options) => {
                    plots.value = options;
                    if (props.data.plots && props.data.plots.length > 0) {
                        data.plot_ids = props.data.plots.map((p) => p.id);
                    }
                    else {
                        data.plot_ids = plots.value.map((p) => p.id);
                    }
                });
            }
        });
        // reset the plot when the orchard changes
        watch(() => data.orchard_id, () => (data.plot_ids = []));
        const save = async () => {
            const valid = await v$.value.$validate();
            if (!valid) {
                return;
            }
            const formData = {
                plot_ids: data.plot_ids,
                date: DateTime.fromJSDate(data.date).toISODate(),
                volume: data.volume,
            };
            const request = props.data.id
                ? irrigationService.update(props.data.id, formData)
                : irrigationService.create(formData);
            spinner.show();
            request
                .then((data) => {
                emit('saved', data);
                emitter.emit('irrigation-saved', data);
            })
                .catch((err) => {
                console.error(err);
            })
                .finally(() => {
                spinner.hide();
            });
        };
        const __returned__ = { orchardService, plotService, spinner, emitter, props, orchards, plots, emit, irrigationService, data, rules, v$, save, get InputNumber() { return InputNumber; }, get Button() { return Button; }, get Dropdown() { return Dropdown; }, get Calendar() { return Calendar; }, get MultiSelect() { return MultiSelect; }, get trans() { return trans; }, get transChoice() { return transChoice; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
